import styled from "@emotion/styled";
import {
  LIGHT_FONT,
  SUCCESS_DARK_BACKGROUND,
  TERTIARY_GREY,
  PRIMARY_GREY,
  SECONDARY_GREY,
  DELETE,
  DELETE_PRESSED,
} from "src/constants/colors";

export const ToastBackDrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  backdrop-filter: blur(4px);
  animation: fadeOut 0.3s ease-in-out 4s forwards;

  @keyframes fadeOut {
    from {
      backdrop-filter: blur(4px);
    }
    to {
      backdrop-filter: blur(0px);
    }
  }
`;

export const ToastContainer = styled.div<{ type: "success" | "error" }>`
  position: fixed;
  bottom: 40px;
  left: 50%;
  width: max-content;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${(props) =>
    props.type === "success" ? "8px 10px 8px 12px" : "8px 10px 8px 15px"};
  border-radius: 40px;
  font-size: 12px;
  font-weight: 700;
  color: ${LIGHT_FONT};
  gap: 10px;
  background: ${(props) =>
    props.type === "success" ? SUCCESS_DARK_BACKGROUND : DELETE};
  box-shadow: 0px 4px 8px 0px #00000057;
  z-index: 1000;
  animation:
    fadeIn 0.3s ease-in-out,
    fadeOut 0.3s ease-in-out 4s forwards;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateX(-50%) translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateX(-50%) translateY(0);
    }
  }

  @keyframes fadeOut {
    to {
      opacity: 0;
    }
  }
`;

export const Message = styled.div`
  display: flex;
  align-items: center;
`;

export const TryAgainButton = styled.button`
  display: flex;
  padding: 6px 10px 6px 11px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border: none;
  border-radius: 40px;
  background: ${PRIMARY_GREY};
  font-size: 12px;
  cursor: pointer;

  &:hover {
    background: ${SECONDARY_GREY};
  }
`;

export const CloseWrapper = styled.div<{ type: "success" | "error" }>`
  display: flex;
  align-items: center;
  border-radius: 18px;
  padding: 4px;
  background: transparent;
  cursor: pointer;

  &:hover {
    background: ${(props) =>
      props.type === "success" ? TERTIARY_GREY : DELETE_PRESSED};
  }
`;
